import { Controller } from '@hotwired/stimulus'
import { Tooltip } from 'bootstrap'

// Connects to data-controller="yu-baby-message"
export default class extends Controller {
  static targets = [
    'yuBabyMessageKey',
    'question',
    'loading',
    'answer',
    'tracks',
    'diaryIds',
    'footerBtnGroup',
    'copyBtn',
    'feedbackModal',
    'errorMessage'
  ]

  static values = {
    answer: String,
    isNew: Boolean,
    isCreate: Boolean
  }

  static outlets = [
    'yu-baby'
  ]

  connect() {
    this.yuBabyOutlet.removeBlankMessage()
    if (this.isNewValue) {
      this.scrollToBottom({ smooth: true })
      this.thinkMessage()
    } else if (this.isCreateValue) {
      this.typeMessage()
    }
  }

  thinkMessage() {
    let messageLimit = 5
    const thinkMessageInterval = setInterval(() => {
      if (messageLimit-- > 0) {
        this.loadingTarget.innerHTML = `${this.loadingTarget.innerHTML} .`
      } else {
        clearInterval(thinkMessageInterval)
        this.loadingTarget.innerHTML = ''
        this.thinkMessage()
      }
    }, 100)
  }

  typeMessage() {
    const answerText = this.answerValue.split('')
    const typeMessageInterval = setInterval(() => {
      if (answerText.length) {
        this.answerTarget.innerHTML = `${this.answerTarget.innerHTML}${answerText.shift()}`
        this.scrollToBottom({ smooth: false })
      } else {
        clearInterval(typeMessageInterval)
        if (this.hasTracksTarget) {
          this.tracksTarget.hidden = false
        }
        if (this.hasFooterBtnGroupTarget) {
          this.footerBtnGroupTarget.dataset.show = 'true'
        }
        this.yuBabyOutlet.enableMessageForm()
        this.scrollToBottom({ smooth: true })
      }
    }, 20)
  }

  copyInfo(e) {
    const yuBabyMessageKey = this.yuBabyMessageKeyTarget.innerText.trim()
    const question = this.questionTarget.innerText.trim()
    const answer = this.answerTarget.innerText.trim()
    const diaryIds = this.diaryIdsTarget.innerText.trim()
    const infoText = [yuBabyMessageKey, question, answer, diaryIds].join('\n\n')
    navigator.clipboard.writeText(infoText)
    this.showTooltip()
    e.preventDefault()
    e.stopPropagation() // Dropdownが閉じるのを抑制する
  }

  showTooltip() {
    const tooltip = new Tooltip(this.copyBtnTarget, {
      title: '情報をコピーしました',
      html: true,
      placement: 'bottom',
      offset: [0, 16]
    })
    tooltip.show()

    this.copyBtnTarget.addEventListener('hidden.bs.tooltip', () => {
      tooltip.dispose()
    }, { once: true })
  }

  scrollToBottom({ smooth }) {
    this.element.scrollIntoView({ behavior: smooth ? 'smooth' : 'instant', block: 'end' })
  }

  setErrorMessage(errorMessage) {
    this.errorMessageTarget.hidden = false
    this.errorMessageTarget.textContent = errorMessage
  }
}
